export default "* Undersøge\n* Fuglevildt\n* Etik\n";